import { statusOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { DateFilter } from '@/containers/billing/register/billingFilters/filter/DateFilter'
import { useShipmentNotificationFilters } from './hooks/useShipmentNotificationFilters'
import { SelectionSummary } from './SelectionSummary'
import { RectangleGroupIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { AdvancedFilters } from './AdvancedFilters'

export const FiltersRow = () => {
  const [selectedDateType, setSelectedDateType] = useState('emision')

  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateShouldArrivedAtFrom,
    updateShouldArrivedAtTo,
    updateStatus,
    clearAllFilters,
    hasActiveFilters,
  } = useShipmentNotificationFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2 w-full">
      <div className="flex w-full flex-col gap-4">
        <div className="flex w-full min-w-0 items-center gap-2">
          <div className="flex-1">
            <SearchQuery
              onSearchChange={updateSearch}
              placeholder="Buscar notificación..."
              searchQuery={filters.search}
            />
          </div>
          <div className="flex flex-wrap items-center justify-end gap-2">
            <SelectFilter
              activeSelections={filters.status}
              icon={<RectangleGroupIcon className="h-4 w-4" />}
              onSelectionsChange={updateStatus}
              placeholder="Buscar estado..."
              searchActive={false}
              selectionOptions={statusOptions}
              title="Estado"
            />
            <DateFilter
              dateFrom={filters.shouldArrivedAtFrom}
              dateTo={filters.shouldArrivedAtTo}
              hideDateTypeSelect
              onDateRangeChange={(from, to) => {
                updateShouldArrivedAtFrom(from || '')
                updateShouldArrivedAtTo(to || '')
              }}
              onDateTypeChange={setSelectedDateType}
              selectedDateType={selectedDateType}
            />
            <AdvancedFilters />
          </div>
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            handleClearFilters={handleClearFilters}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            setShouldArriveAtFrom={updateShouldArrivedAtFrom}
            setShouldArriveAtTo={updateShouldArrivedAtTo}
            setStatus={updateStatus}
            shouldArriveAtFrom={filters.shouldArrivedAtFrom}
            shouldArriveAtTo={filters.shouldArrivedAtTo}
            status={filters.status}
            statusOptions={statusOptions}
          />
        )}
      </div>
    </div>
  )
}
